import { render, staticRenderFns } from "./FilesTabOfPublicTender.vue?vue&type=template&id=7da33336&scoped=true&"
import script from "./FilesTabOfPublicTender.vue?vue&type=script&lang=js&"
export * from "./FilesTabOfPublicTender.vue?vue&type=script&lang=js&"
import style0 from "./FilesTabOfPublicTender.vue?vue&type=style&index=0&id=7da33336&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da33336",
  null
  
)

export default component.exports